"use strict";

var LoggerInstance = require("js-logger").get("ExpanderActions");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var ExpanderStore = require("../stores/ExpanderStore");

var ExpanderActions = {
	initializeStore: function (options) {
		var action = Object.assign({}, options, { actionType: Constants.EXPANDER_INITIALIZE });
		Dispatcher.dispatch(action);
	},

	toggle: function ($target, options) {
		options = options || {};
		// Allow multiple expanders to be open at the same time.
		var $expander = $target.parent();
		var $content = $expander.find("[data-component='expanderContainer.expander.content']").first();

		switch (options.action) {
			case "expand":
				$target.removeClass("collapsed");
				$content.addClass("in");
				break;
			case "collapse":
				$target.addClass("collapsed");
				$content.removeClass("in");
				break;
			case "toggle":
				$target.toggleClass("collapsed");
				$content.toggleClass("in");
				break;
			default:
				break;
		}
	},

	toggleExpander: function (event) {
		event = event || windows.event;
		if (!event || !event.target || event.type !== "click") {
			return false;
		}

		var isDesigner = ExpanderStore.get("isDesignMode");
		if (isDesigner && event.type === "click" && (!event.ctrlKey && !event.metaKey)) {
			return true;
		}
		if (!isDesigner) {
			event.preventDefault();
			event.stopPropagation();
		}

		var $target,
			$expanderComponent;

		$target = $(event.target);
		$expanderComponent = $target.closest("[data-component='expanderContainer']");

		if (!$expanderComponent.is("[data-accordion]")) {
			this.toggle($target, { action: "toggle" });
		} else {
			// Only one expander can be open at a time so close them all first
			$expanderComponent.find("[data-component='expanderContainer.expander'] > label").each((index, element) => {
				if (element !== $target[0]) {
					this.toggle($(element), { action: "collapse" });
				}
			});
			// Expand the selected expander
			this.toggle($target, { action: "expand" });
		}
		return false;
	},
};

module.exports = ExpanderActions;


// WEBPACK FOOTER //
// ./Javascript/actions/ExpanderActions.jsx